
import axios from '../utils/http';

// 获取分类树
const getCategoryTree = params => {
    return axios.request({
        data: {
            ...params
        },
        method: 'get',
        url: '/category/getCategoryTree'
    })
}

// 文章列表通用接口+分类+城市
const getArticleList = params => {
    return axios.request({
        data: {
            ...params
        },
        method: 'get',
        url: '/v1/article/getArticleList'
    })
}

 export default {
    getCategoryTree,
    getArticleList
 }